import React, { Fragment, useState } from "react";
import { Button, Form, Row, Col, InputGroup } from "react-bootstrap";
import { getDateFormat } from "../common";

/**
 * 개인 수행 평가 양식
 * @param {*} param0
 * @returns
 */
export const QuestEditForm = ({ quest, handleSave, handleClose }) => {
  const [btnSaveDirty, setBtnSaveDirty] = useState(false);
  const [gps, setGPS] = useState({
    latitude: quest.building.position.latitude,
    longitude: quest.building.position.longitude,
    meter: quest.info.gpsMeter,
  });

  const handleGPS = (e) => {
    let check = /^[.0-9]+$/;
    if (check.test(e.target.value)) {
      const { name, value } = e.target;
      setGPS((cur) => {
        return { ...cur, [name]: value };
      });
      setBtnSaveDirty(true);
    }
  };

  const handleClickSave = () => {
    handleSave({
      latitude: gps.latitude,
      longitude: gps.longitude,
      meter: gps.meter,
    });
    setBtnSaveDirty(false);
  };

  return (
    <Fragment>
      <Row className="mt-2">
        <Col className="col-3">건물</Col>
        <Col>{quest.building.name}</Col>
      </Row>
      <Row className="mt-2">
        <Col className="col-3">미니 게임</Col>
        <Col>{quest.game.name}</Col>
      </Row>
      <Row className="mt-2">
        <Col className="col-3">GPS 위치 </Col>
        <Col>
          <InputGroup className="mb-3">
            <Form.Control
              type="number"
              //placeholder="00.00"
              name="latitude"
              value={gps.latitude}
              onChange={handleGPS}
            />
            <Form.Control
              type="number"
              //placeholder="00.00"
              name="longitude"
              value={gps.longitude}
              onChange={handleGPS}
            />
          </InputGroup>
        </Col>
      </Row>
      <Row>
        <Col className="col-3">GPS 인증 범위(Meter)</Col>
        <Col className="col-3">
          <Form.Control
            type="number"
            placeholder="50"
            name="meter"
            value={gps.meter}
            onChange={handleGPS}
          />
        </Col>
      </Row>
      
      <br />
      <Button disabled={!btnSaveDirty} onClick={handleClickSave}>
        저장
      </Button>
      <Button onClick={handleClose} className="ms-3" variant="info">
        확인
      </Button>
    </Fragment>
  );
};
